<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Account Records</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Account Records</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Records</h5>
                  <span>Account Records</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="invoiceListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Previous Amount</th>
                          <th>Current Amount</th>
                          <th>New Amount</th>
                          <th>Account type</th>
                          <!-- <th>Sub. Total</th> -->
                          <!-- <th>Payment status</th> -->
                          <!-- <th>Account PDF</th> -->
                          <!-- <th>Action</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          align="center"
                          v-for="(item, index) in invoice_list"
                          :key="index"
                        >
                          <td>{{ index+1 }}</td>
                          <td>{{ parseInt(item.previous_amount) }}</td>
                          <td>{{ parseInt(item.current_amount) }}</td>
                          <td>{{ parseInt(item.new_amount) }}</td>
                          <!-- <td>{{ item.type === 1? "In" : "Out" }}</td> -->
                          <!-- <td>{{ parseInt(item.sub_total_price) }}</td> -->

                          <td>
                            <span class="badge badge-success" v-if="item.type === 1"
                              >In</span
                            >
                            <span class="badge badge-warning" v-if="item.type === 2"
                              >Out</span
                            >
                          </td>
                          <!-- <td>
                            <button
                              class="btn btn-sm btn-primary"
                              @click="downloadPDF(item)"
                            >
                              Download
                            </button>
                          </td> -->
                          <!-- <td>
                            <button
                              class="btn btn-danger btn-xs"
                              type="button"
                              data-original-title="btn btn-danger btn-xs"
                              title=""
                              @click.prevent="deleteType(item.id)"
                            >
                              Delete
                            </button>
                            <button
                              class="btn btn-primary btn-xs"
                              type="button"
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal1"
                              @click.prevent="selectedAction(item.items)"
                            >
                              <span class="title"> Details</span>
                            </button>
                          </td> -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import $ from "jquery";
import customerAPI from "../../services/customer.API.js";

export default {
  name: "CustomerList",
  components: {},
  data() {
    return {
      invoice_list: [],
    };
  },
  methods: {
    // district list
    getList() {
      customerAPI.getList().then(
        (response) => {
          this.customerList = response.data.data;
          console.log(response.data.data);
        },
        (err) => {
          if (err.response.data.success === false) {
            this.customerList = [];
          }
        }
      );
    },

    // delete
    deleteType(id) {
      if (id) {
        customerAPI.deleteCustomer(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        customerAPI.changeStatus(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select connection type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },
  },
  mounted() {
    //   list
    customerAPI.accountRecordOwn().then((res) => {
      if (res?.data?.data) {
        this.invoice_list = res.data.data;
        setTimeout(() => {
          $("#invoiceListTBL").DataTable({
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            pageLength: 10,
            info: false,
            targets: "no-sort",
            bSort: false,
            order: [],
            bFilter: true,
            bInfo: false,
            //   bLengthChange: false,
            bDestroy: true,
          });
        });
      }
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

span.switch-state:before {
  background: #000 !important;
  margin-bottom: -2px !important;
}

span.switch-state {
  border: 2px solid #000 !important;
}
</style>
